class CarouselDots extends HTMLElement {
  constructor() {
    super();
    this.maxVisibleDots = 4;
    this.carousel = document.getElementById(this.getAttribute('aria-controls'));
    this.buttons = Array.from(this.querySelectorAll('button'));
    this.totalDots = this.buttons.length;
    this.currentIndex = 0;

    this.init();
  }

  init() {
    this.updateVisibleDots();
    this.carousel.addEventListener('scroll', () => this.handleScroll());
  }

  handleScroll() {
    const scrollLeft = this.carousel.scrollLeft;
    const width = this.carousel.offsetWidth;
    const scrollWidth = this.carousel.scrollWidth;
    
    // Calculate current index based on scroll position
    const newIndex = Math.round((scrollLeft / (scrollWidth - width)) * (this.totalDots - 1));
    
    if (newIndex !== this.currentIndex) {
      this.currentIndex = newIndex;
      this.updateVisibleDots();
    }
  }

  updateVisibleDots() {
    // Calculate which dots should be visible
    let start = Math.max(0, Math.min(this.currentIndex - 1, this.totalDots - this.maxVisibleDots));
    let end = Math.min(start + this.maxVisibleDots, this.totalDots);

    // Update visibility and current state of dots
    this.buttons.forEach((button, index) => {
      const isVisible = index >= start && index < end;
      button.style.display = isVisible ? 'block' : 'none';
      button.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
    });
  }
}

customElements.define('carousel-dots', CarouselDots); 